/** App API del módulo Catálogo — hooks, use cases, overlay store, navigation.
 * Importar desde acá para evitar require cycles. */

export {
  ImportProductFromRemoteValidationError,
} from './application/importProductFromRemoteSuggestion';

export {
  importProductFromRemoteSuggestion,
} from './application/importProductFromRemoteSuggestion';

export {
  assertWithinProductPlanLimit,
  CatalogPlanLimitExceededError,
  getCatalogPlanLimitExceededMessage,
} from './application/catalogPlanLimits';

export { useCatalogListController } from './application/useCatalogListController';
export { useProductVariantsEnabled } from './application/useProductVariantsEnabled';
export { useMenuModifiersEnabled } from './application/useMenuModifiersEnabled';

export { bulkPreviewScopeHint, bulkAllCatalogWarning, isBulkPreviewScopeAllowed } from './application/bulkPreviewScope';

export {
  useCatalogOverlayStore,
  resetCatalogTabOverlays,
} from './store/useCatalogOverlayStore';
export type { CatalogProductFormMode } from './store/useCatalogOverlayStore';

export { openCatalogNewService, openCatalogNewProduct, openCatalogMasters } from './application/catalogNavigation';
export type { CatalogMastersSection } from './application/catalogNavigation';
